import { createRouter, createWebHashHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import SessionPreview from '../views/SessionPreview.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/preview',
    name: 'preview',
    component: SessionPreview,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
